<div *ngIf="control.cohort" class="ap-filter">
	<input type="checkbox" id="switch"
		   (change)="onChange($event)"
		   [checked]="control.cohort.options[0].active" />
	<label for="switch">
		<span>{{control.cohort.options[0].value}}</span>
	</label>
</div>
